var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
export var CrossIcon = function (props) {
    return (jsx("div", __assign({ sx: {
            display: 'inline-block',
            width: '1em',
            height: '1em',
        }, "aria-label": "Close" }, props),
        jsx("svg", { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", css: {
                width: '100%',
                height: '100%',
            } },
            jsx("line", { x1: 15, y1: 15, x2: 85, y2: 85, css: { stroke: 'currentColor', strokeWidth: 7 } }),
            jsx("line", { x1: 15, y1: 85, x2: 85, y2: 15, css: { stroke: 'currentColor', strokeWidth: 7 } }))));
};
//# sourceMappingURL=CrossIcon.js.map